/**
 * Shown while the session resolves. Deliberately a logo + quiet spinner rather than
 * a skeleton of the shell: we do not yet know the user's role, so we cannot know
 * which nav sections to skeleton, and guessing wrong makes the app appear to
 * rearrange itself the moment the session lands.
 */
export function FullPageSpinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background">
      <img src="/favicon.png" alt="" className="size-10 rounded-lg" draggable={false} />
      <div
        className="size-5 animate-spin rounded-full border-2 border-muted border-t-primary"
        role="status"
        aria-label={label}
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
